<template>
  <div class="box">
    <div>
      <el-form  :inline="true" class="demo-form-inline" size="mini">
        <el-form-item label="栏目:">
          <el-select v-model="params.categoryId" clearable style="width: 90px;margin-right: 5px"  placeholder="栏目">
            <el-option label="全部" value="">
            </el-option>
            <el-option v-for="item in categoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
      </el-form>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="supplyList.records"
        stripe
        :height="windowHeight"
        style="width: 100%;z-index: 1;font-size: 12px">
        <el-table-column
          label="创建日期"
          label-class-name="header">
          <template slot-scope="scope">
            <span>{{new Date(scope.row.createDate).format("yyyy-MM-dd")}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          label-class-name="header">
        </el-table-column>
        <el-table-column
          prop="contact"
          label="电话"
          label-class-name="header">
        </el-table-column>
        <el-table-column
          label="所属栏目"
          label-class-name="header">
          <template slot-scope="scope">
            <el-select @change="changeCategory(scope.row)" size="mini" style="width: 90px;" v-model="scope.row.categoryId" placeholder="请选择">
              <el-option v-for="item in categoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="是否显示"
          label-class-name="header">
          <template slot-scope="scope">
            <el-switch
              :name="scope.row.name"
              v-model="scope.row.isShow"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value=1
              :inactive-value=0
              @change="changeShow(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="备注/删除"
          label-class-name="header">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
            @click="deleteReceiptOrder(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.current"
        :page-sizes="[15, 30, 50, 100]"
        :page-size="params.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="supplyList.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getSupply, updateSupply, deleteSupply } from '../../../api/supply'
export default {
  name: 'ReceiptOrderList',
  data () {
    return {
      appId: '',
      loading: true,
      windowHeight: '',
      params: {
        size: 15,
        current: 1,
        categoryId: ''
      },
      categoryList: [],
      supplyList: {}
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.appId = to.params.id
      vm.getSupplyList(to.params.id, null, 15, 1)
    })
  },
  created () {
    this.windowHeight = document.documentElement.offsetHeight - 308
  },
  methods: {
    deleteReceiptOrder (item) {
      this.$confirm('是否删除该经理?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSupply(item.supplyId, this.appId).then(() => {
          this.getSupplyList(this.appId, this.params.categoryId, this.params.size, this.params.current)
        })
      })
    },
    changeShow (item) {
      updateSupply(this.appId, item.supplyId, item).then((response) => {
        item = response.data.data
      })
    },
    changeCategory (item) {
      updateSupply(this.appId, item.supplyId, item).then((response) => {
        item = response.data.data
      })
    },
    getSupplyList (appId, categoryId, pageSize, pageCurrent) {
      let _this = this
      _this.loading = true
      setTimeout(() => {
        getSupply(appId, categoryId, pageSize, pageCurrent).then((response) => {
          _this.supplyList = response.data.data.page
          _this.categoryList = response.data.data.appCategories
          _this.loading = false
        })
      }, 500)
    },
    handleSizeChange (val) {
      this.params.size = val
      this.getSupplyList(this.appId, this.params.categoryId, this.params.size, this.params.current)
    },
    handleCurrentChange (val) {
      this.params.current = val
      this.getSupplyList(this.appId, this.params.categoryId, this.params.size, this.params.current)
    },
    search () {
      this.params.current = 1
      this.getSupplyList(this.appId, this.params.categoryId, this.params.size, this.params.current)
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.box
  padding 18px
  background #fff
  border-radius 5px
  font-size 12px
  transition .3s
  box-shadow 0 0 8px 0 rgba(156, 156, 156, 0.6), 0 2px 4px 0 rgba(232,237,250,0.5)
  .filter-item
    display: inline-block
    vertical-align: middle
    margin-bottom: 10px
    margin-right 5px
  .header
    font-size 12px !important
</style>
